// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2642":"444b1583","3164":"390b28b0","3502":"444b1583","3766":"444b1583","7064":"444b1583","9279":"444b1583"}[chunkId] + ".chunk.css";
};